export interface PolicyFileRes {
  id: number;
  fileName: string;
  fileKey: string;
  fileSize: number;
  createTime: string;
}

export interface PolicyFileReq {
  fileName: string;
  fileKey: string;
  fileSize: number;
}

export interface PolicyListReq {
  isTemp: boolean;
  exposeSiteLanguage: string;
}

export interface PolicyVersionRes {
  originId: number;
  id: number;
  exposeSiteLanguage: string;
  version: string;
  updateTime: string;
  expose: boolean;
}

export interface PolicyCreateReq {
  isTemp: boolean;
  version: string;
  expose: boolean;
  revisionTime: string;
  effectiveTime: string;
  description: string;
  exposeSiteLanguage: string;
  files: PolicyFileReq[];
}

export const EmptyPolicyCreateReq: PolicyCreateReq = {
  isTemp: false,
  version: '',
  expose: false,
  revisionTime: '',
  effectiveTime: '',
  description: '',
  exposeSiteLanguage: '',
  files: [],
};

export interface PolicyDetailRes {
  id: number;
  originId: number;
  version: string;
  expose: boolean;
  revisionTime: string;
  effectiveTime: string;
  description: string;
  exposeSiteLanguage: string;
  writerId: string;
  lastModifierId: string;
  createTime: string;
  updateTime: string;
  files: PolicyFileRes[];
}

export interface PolicyUpdateReq {
  isTemp: boolean;
  id: number;
  originId: number;
  version: string;
  expose: boolean;
  revisionTime: string;
  effectiveTime: string;
  description: string;
  exposeSiteLanguage: string;
  files: PolicyFileReq[];
}

export const EmptyPolicyUpdateReq: PolicyUpdateReq = {
  isTemp: false,
  id: 0,
  originId: 0,
  version: '',
  expose: false,
  revisionTime: '',
  effectiveTime: '',
  description: '',
  exposeSiteLanguage: '',
  files: [],
};
